import { useEffect, useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { apiUrl } from '@/config/api';

const TIPS_RETURN_URL_KEY = 'tips_return_url';
const TIPS_CONTEXT_KEY = 'tips_context';
const TIPS_SUCCESS_KEY = 'tips_success';
const TIPS_RECEIPT_KEY = 'tips_receipt';
const TIPS_FAILURE_KEY = 'tips_failed';

const PaymentReturnPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { t } = useTranslation('game');

  const paymentType = useMemo(() => searchParams.get('paymentType') || '', [searchParams]);
  const orderReference = useMemo(
    () => searchParams.get('orderReference') || searchParams.get('paymentId') || '',
    [searchParams],
  );

  useEffect(() => {
    let isMounted = true;

    const finalizeTipsPayment = async () => {
      if (typeof window === 'undefined') {
        return;
      }

      const returnUrl = sessionStorage.getItem(TIPS_RETURN_URL_KEY) || '/dashboard/create-game';
      let isSuccess = false;

      if (paymentType === 'tips' && orderReference) {
        try {
          const response = await fetch(
            apiUrl(`/api/payments/wayforpay/status?orderReference=${encodeURIComponent(orderReference)}&paymentType=tips`),
          );
          const data = await response.json().catch(() => ({}));

          if (response.ok && data?.status === 'approved' && data?.type === 'tips') {
            const contextRaw = sessionStorage.getItem(TIPS_CONTEXT_KEY);
            const context = contextRaw ? JSON.parse(contextRaw) : null;
            const receipt = {
              amountEur: Number.isFinite(data?.amountEur) ? data.amountEur : context?.amountEur || null,
              conductorName: context?.conductorName || null,
              timestamp: new Date().toISOString(),
            };
            sessionStorage.setItem(TIPS_SUCCESS_KEY, 'true');
            sessionStorage.setItem(TIPS_RECEIPT_KEY, JSON.stringify(receipt));
            isSuccess = true;
          }
        } catch (error) {
          isSuccess = false;
        }
      }

      if (!isSuccess && paymentType === 'tips') {
        sessionStorage.setItem(TIPS_FAILURE_KEY, 'true');
      }

      if (isMounted) {
        navigate(returnUrl, { replace: true });
      }
    };

    finalizeTipsPayment();

    return () => {
      isMounted = false;
    };
  }, [navigate, orderReference, paymentType]);

  return (
    <div className="page-loader">
      <p>{t('paymentReturn.pending')}</p>
    </div>
  );
};

export default PaymentReturnPage;
